import { render, staticRenderFns } from "./EModalDuplicarAulaComplementar.vue?vue&type=template&id=2d5b7eb8"
import script from "./EModalDuplicarAulaComplementar.vue?vue&type=script&lang=js"
export * from "./EModalDuplicarAulaComplementar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports